import axios from 'axios';
import AppConstants from '../constants/AppConstants';
import { AxiosApiClient, AxiosTokenClient } from '../proxy/ProxyClients';

const TokenService = {
  signIn: (userName: string, password:string, rememberMe: any) => AxiosApiClient.token({
    userName,
    password,
    client_Id: AppConstants.APP_CLIENT_ID,
    rememberMe
  }).then((resp) => resp),
  getTokenFromRefreshToken: (token: string, refreshToken: string) => axios.post(`${AppConstants.BASE_API_URL}/api/Token/Refresh`, {
    access_Token: token,
    refresh_Token: refreshToken,
    client_Id: AppConstants.APP_CLIENT_ID
  })
};

export default TokenService;
